import React from 'react';
import { ChevronDown } from 'lucide-react';

import { cn } from '@epoch-ui/lib/utils';
import { Button } from '@epoch-ui/components/Button/button';
import { Popover, PopoverContent, PopoverTrigger } from '@epoch-ui/components/Popover/popover';

export interface ComboBoxProps {
  triggerContent: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  spanClassname?: string;
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  contentAvoidCollisions?: boolean;
  disabled?: boolean;
  error?: boolean;
}

export const ComboBox: React.FC<ComboBoxProps> = ({
  triggerContent,
  children,
  className,
  isOpen,
  onOpenChange,
  spanClassname,
  contentAvoidCollisions = false,
  disabled = false,
  error
}) => {
  return (
    <Popover open={isOpen} onOpenChange={onOpenChange} modal>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={isOpen}
          className={cn(
            'tw-h-12 tw-w-full tw-justify-between tw-rounded-lg tw-border-[1.5px] tw-border-border-grey tw-px-4 tw-py-3 tw-text-sm tw-font-normal tw-leading-5 tw-text-medium-grey',
            error && 'tw-border-destructive-foreground',
            className
          )}
          disabled={disabled}
        >
          <span
            className={cn('tw-overflow-hidden tw-truncate tw-whitespace-nowrap', spanClassname)}
          >
            {triggerContent}
          </span>
          <ChevronDown color="#555555" />
        </Button>
      </PopoverTrigger>
      <PopoverContent
        align="start"
        avoidCollisions={contentAvoidCollisions}
        className="tw-w-[var(--radix-popover-trigger-width)] tw-rounded-sm tw-p-3"
        onOpenAutoFocus={(e): void => e.preventDefault()}
      >
        {children}
      </PopoverContent>
    </Popover>
  );
};
